import React from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import Dashboard from "../component/Dashboard/Dashboard.jsx"
const Dashboardpage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  return (
    <>
    <Header/>
    <Dashboard/>
    <Footer/>
    </>
  )
}

export default Dashboardpage